import moment from 'moment';
import { Button } from '@tempmee/react';

import { colors } from '@tempmee/tailwind';
import { capitalizeEveryFirstLetter } from '../../../utils/String';
import { TableData } from '../../../commonComponents/Table/TableData';
import { WC_MANAGEMENT_STATUS } from '../utils';
import { OutlineCheckCircleIcon, OutlineXCircleIcon } from '@tempmee/react-icons';

export const renderRow = (item, handleOnClick) => (
  <>
    <TableData text={item.officeName} />
    <TableData text={item.state} />
    <TableData
      text={item.requestedDate ? moment(item.requestedDate).format('ddd, MMM DD, YYYY') : '-'}
    />
    <td
      style={{
        fontFamily: 'Nunito',
        fontSize: 16,
        color: colors.neutral[600],
        textAlign: 'center',
      }}
    >
      {item.workerClassificationType
        ? capitalizeEveryFirstLetter(item.workerClassificationType)
        : '-'}
    </td>
    <td>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <Button
          variant="tertiary"
          size="xs"
          LeadingIcon={<OutlineXCircleIcon size={16} />}
          onClick={() => handleOnClick(item, WC_MANAGEMENT_STATUS.DECLINED)}
        >
          Decline
        </Button>
        <Button
          size="xs"
          LeadingIcon={<OutlineCheckCircleIcon size={16} />}
          onClick={() => handleOnClick(item, WC_MANAGEMENT_STATUS.CONFIRMED)}
        >
          Approve
        </Button>
      </div>
    </td>
  </>
);
